export default "__VITE_ASSET__34225830__"